import React, { useState, useEffect } from 'react';
import { Layout, Button, Input, Spin, Avatar, Progress, Row, Col, notification } from 'antd';
import { CheckCircleOutlined, LoadingOutlined, CaretLeftOutlined, CaretRightOutlined, ContactsTwoTone, ConsoleSqlOutlined } from '@ant-design/icons';
import MyCombobox from './DiffCheckerSourceDestinationSelector';
import ObjectAndFieldSelector from './DiffCheckerObjectAndFieldSelector';
import ChildRelationShipSelector from './DiffCheckerChildRelationShipSelector';
import MyTableComponent from './DiffCheckerNewDataRender';
import axios from 'axios';
import { DiffChecker_URL } from '../../Components/Constant';
import { use } from 'react';
import Cookies from 'js-cookie';

const { Sider, Content } = Layout;

const DiffCheckerTabs = ({ comparejourney }) => {
    const [isOpen] = useState(true);
    const [stage1Open, setStage1Open] = useState(false);
    const [stage2Open, setStage2Open] = useState(false);
    const [stage3Open, setStage3Open] = useState(false);
    const [comparejouney,setCompareJourney]=useState(comparejourney || null);
    const [sourceSelection, setSourceSelection] = useState(comparejouney?.Source || null);
    const [destinationSelection, setDestinationSelection] = useState(comparejouney?.Destination || null);
    const [objectSelection, setObjectSelection] = useState(
        comparejouney?.objectConfig?.object 
            ? Array.isArray(comparejouney.objectConfig.object   )
                ? comparejouney.objectConfig.object
                : [{ label: comparejouney.objectConfig.object, id: comparejouney.objectConfig.object }]
            : []
    );
    const [externalIdSelection, setExternalIdSelection] = useState(comparejouney?.objectConfig?.externalId || []);
    const [parentfieldSelection, setParentfieldSelection] = useState(comparejouney?.objectConfig?.fields || []);
    const [relationShipState, setRelationShipState] = useState({});
    const [diffResults, setDiffResults] = useState({});
    const [comparisonInProgress, setComparisonInProgress] = useState(false);
    const [childRows, setChildRows] = useState(comparejouney?.childData || []);
    const [selectedDiv, setSelectedDiv] = useState('div1');
    const [collapsed, setCollapsed] = useState(false); // <-- sidebar state
    const [titlefield, setTitleField] = useState(comparejouney?.objectConfig?.titlefield || []);
    const [childTitlefield, setchildTitleField] = useState(null);
    const [childTitleFieldMap, setChildTitleFieldMap] = useState({});

    const [comparejourneyId, setCompareJourneyId] = useState(comparejouney?._id || null);
    const [sourceRecords,setSourceRecords]=useState(0);
    const [destinationRecords,setDestinationRecords]=useState(0);
    const [filterQuery,setFilterQuery]=useState('');
    const [orderby, setOrderby] = useState(comparejouney?.objectConfig?.orderby || null);																						 
    const userId=Cookies.get('userId');

const getExternalIds = () =>
  externalIdSelection?.map(e => e.label ?? e) || [];

    useEffect(() => {
        if (comparejouney) {
            if (comparejouney.childData && comparejouney.childData.length > 0) {
                setStage1Open(true);
                setStage2Open(true);
                setSelectedDiv('div3');
            } else if (comparejouney.objectConfig && (!comparejouney.childData || comparejouney.childData.length === 0)) {
                setStage1Open(true);
                setStage2Open(true);
                setSelectedDiv('div3');
            } else if (!comparejouney.objectConfig) {
                setStage1Open(true);
                setSelectedDiv('div2');
            }
        }
    }, [comparejouney]);



    const handleCallback = (srcSel, destSel) => {
        setSourceSelection(srcSel);
        setDestinationSelection(destSel);
        setStage1Open(
            srcSel && destSel && Object.keys(srcSel).length > 0 && Object.keys(destSel).length > 0
        );
    };

    const handleObjectSelectionCallback = (objectData, externalIdData, titlefield, fieldsData, orderbyData ) => {
       
        setObjectSelection(objectData || []);
        setExternalIdSelection(externalIdData || []);
        setParentfieldSelection(fieldsData || []);
        setTitleField(titlefield || null);
        if (orderbyData) setOrderby(orderbyData);
        setStage2Open(objectData?.length !== 0 && externalIdData?.length !== 0 && fieldsData?.length !== 0);
    };

    const handleChildSelectionCallback = (childState) => {
        setRelationShipState(childState);
        setChildRows(childState.childRows);
        setchildTitleField(childState.childTitleField?.label || childState.childTitleField);
        setChildTitleFieldMap(childState.childTitleFieldMap || {});
        setStage3Open(true);
    };

    const handleComparisonButtonClick = () => {
        setComparisonInProgress(true);
        let childData = {};
        if (childRows[0]?.objectSelectedValue?.relationshipName) {
            childRows?.forEach((value) => {
                childData[value?.objectSelectedValue?.relationshipName] = {
                    listOfFields: value?.fieldSelections,
                    childSObject: value?.objectSelectedValue?.childSObject,
                    parentFieldName: value?.objectSelectedValue?.field,
                    externalIdField: value?.externalIdSelection,
                    childTitleField: value?.titleFieldSelection,
                };
            });
        }

        // console.log('childData', childData);


        if (childRows[0]?.objectSelectedValue) {

            const childs = childRows
                .filter(row => row.objectSelectedValue) // only rows where child object is selected
                .map(row => {
                    // The child object key in your childRows
                    const childKey = row.objectSelectedValue.relationshipName || row.objectSelectedValue.childSObject;
                    return {
                        childObject: row.objectSelectedValue.childSObject || comparejouney?.childData?.find(child => child.childObject === row.objectSelectedValue.childSObject)?.childObject, 
                        externalId: row.externalIdSelection || row.objectSelectedValue.externalIdField, 
                        relationshipName: row.objectSelectedValue.relationshipName || comparejouney?.childData?.find(child => child.childObject === row.objectSelectedValue.childSObject)?.relationshipName,
                        field: row.objectSelectedValue.field || comparejouney?.childData?.find(child => child.childObject === row.objectSelectedValue.childSObject)?.field,
                        childTitleField: row.titleFieldSelection,
                        fields: row.fieldSelections?.length
                            ? row.fieldSelections
                            : row.objectSelectedValue.listOfFields || [], 
                    };
                });

            const body = {
                id: comparejourneyId || undefined,
                userId:userId || undefined,
                Source: {
                    Id: sourceSelection?.Id,
                    Name: sourceSelection?.Name
                },
                Destination: {
                    Id: destinationSelection?.Id,
                    Name: destinationSelection?.Name
                },
                objectConfig: {
                    object: objectSelection[0]?.label || comparejouney?.objectConfig?.object,
                    externalId: getExternalIds(),
                    orderby: orderby || comparejouney?.objectConfig?.orderby || "",
                    titlefield: titlefield?.label || comparejouney?.objectConfig?.titlefield,
                    fields: (parentfieldSelection && parentfieldSelection.length > 0)
                        ? parentfieldSelection.map((elem) => elem.label ?? elem)
                        : comparejouney?.objectConfig?.fields || [],
                },
                childData: childs,
                filterquery: filterQuery || comparejouney?.filterQuery || '',

            }


            const res = axios.post(`${DiffChecker_URL}/comparejourney/save`, body);
        }

        // console.log('childData', childData);

        const requestData = {
            Target: destinationSelection?.Id,
            Source: sourceSelection?.Id,
            Object: objectSelection[0]?.label || comparejouney?.objectConfig?.object,
            titlefield: titlefield?.label || comparejouney?.objectConfig?.titlefield,
            orderby: orderby,
																				 
            Fields: (parentfieldSelection && parentfieldSelection.length > 0)
                ? parentfieldSelection.map((elem) => elem.label ?? elem)
                : comparejouney?.objectConfig?.fields || [],
            ChildFields: childData || {},
            externalId: getExternalIds(),
            filterquery: filterQuery || comparejouney?.filterQuery || '',
            comparejourneyId: comparejourneyId || null,
        };


        axios
            .post(`${DiffChecker_URL}/run/diff/check`, requestData)
            .then((res) => {
                setDiffResults(res.data.DiffData);
                setSourceRecords(res.data?.ResponseSummary?.totalSourceRecords || 0);
                setDestinationRecords(res.data?.ResponseSummary?.totalTargetRecords || 0);
                setSelectedDiv('div4');
                setComparisonInProgress(false);
            })
            .catch((error) =>{
                if(!error){
                    openNotification('Error', 'Something went wrong while running the comparison.');
                }else{

                
                openNotification('Error', error?.response.data.detail);
                }
                setComparisonInProgress(false)
    });
    };

    const openNotification = (message, description) => {
        notification.error({
            message,
            description,
            placement: 'topRight',
            duration: 3,
        });
    };
    const openNotificationSuccess = (message, description) => {
        notification.success({
            message,
            description,
            placement: 'topRight',
            duration: 3,
        });
    };

    const handleSaveDiv1 = async () => {
        if (!sourceSelection || !destinationSelection) {
            openNotification('Validation Error', 'Please select both Source and Destination.');
            return;
        }

        try {

            const childs = childRows
                .filter(row => row.objectSelectedValue) // only rows where child object is selected
                .map(row => {
                    // The child object key in your childRows
                    const childKey = row.objectSelectedValue.relationshipName || row.objectSelectedValue.childSObject;

                    return {
                        childObject: row.objectSelectedValue.childSObject, // SBQQ__PriceCondition__c
                        externalId: row.externalIdSelection || row.objectSelectedValue.externalIdField, // External_Id__c
                        relationshipName: row.objectSelectedValue.relationshipName,
                        field: row.objectSelectedValue.field,
                        childTitleField: row.titleFieldSelection,
                        fields: row.fieldSelections?.length
                            ? row.fieldSelections
                            : row.objectSelectedValue.listOfFields || [], // fallback to all fields
                    };
                });

            const body = {
                _id: comparejouney?._id || undefined,
                userId:userId || undefined,
                Source: {
                    Id: sourceSelection?.Id,
                    Name: sourceSelection?.Name
                },
                Destination: {
                    Id: destinationSelection?.Id,
                    Name: destinationSelection?.Name
                },
                objectConfig: {
                    object: objectSelection[0]?.label || comparejouney?.objectConfig?.object,
                    externalId: getExternalIds(),
																													 
                    orderby: orderby,
                    titlefield: titlefield?.label || comparejouney?.objectConfig?.titlefield,
																				 
                    fields: (parentfieldSelection && parentfieldSelection.length > 0)
                        ? parentfieldSelection.map((elem) => elem.label ?? elem)
                        : comparejouney?.objectConfig?.fields || [],
                },
                childData: childs || [],
                filterquery: filterQuery || comparejouney?.filterQuery || '',


            };
            console.log('body in div1', body);
            // Await the response
            const res = await axios.post(`${DiffChecker_URL}/comparejourney/save`, body);

            console.log('res', res);
            console.log('res.data.id', res?.data?.id);

            if (res?.data?.id) {
                setCompareJourney(res.data.data);
                setCompareJourneyId(res.data.id);
                setStage2Open(true);
                setSelectedDiv('div2');
                openNotificationSuccess('Success', '🚀 DiffInsight Journey has been successfully initiated');
            } else {
                openNotification('Error', 'Failed to create Compare Journey.');
            }
        } catch (error) {
            console.error(error);
            openNotification('Error', 'Something went wrong while creating Compare Journey.');
        }
    };


    const handleSaveDiv2 = async () => {

        if (!(objectSelection.length > 0) || !(externalIdSelection.length > 0) || !(titlefield) || !(parentfieldSelection.length > 0)) {
            let missingFields = [];
            if (!(objectSelection.length > 0)) missingFields.push('Object');
            if (!(externalIdSelection.length > 0)) missingFields.push('External ID');
            if (!(titlefield)) missingFields.push('Title Field');
            if (!(parentfieldSelection.length > 0)) missingFields.push('Parent Field');

            openNotification('Validation Error', `Please select: ${missingFields.join(', ')}`);
        }
        else {
            try {
                
                const childs = childRows
                    .filter(row => row.objectSelectedValue) // only rows where child object is selected
                    .map(row => {
                        // The child object key in your childRows
                        const childKey = row.objectSelectedValue.relationshipName || row.objectSelectedValue.childSObject;
                        return {
                            childObject: row.objectSelectedValue.childSObject, // SBQQ__PriceCondition__c
                            externalId: row.externalIdSelection || row.objectSelectedValue.externalIdField, // External_Id__c
                            relationshipName: row.objectSelectedValue.relationshipName || comparejouney?.childData?.find(child => child.childObject === row.objectSelectedValue.childSObject)?.relationshipName,
                            field: row.objectSelectedValue.field || comparejouney?.childData?.find(child => child.childObject === row.objectSelectedValue.childSObject)?.field,
                            childTitleField: row.titleFieldSelection,
                            fields: row.fieldSelections?.length
                                ? row.fieldSelections
                                : row.objectSelectedValue.listOfFields || [], // fallback to all fields
                        };
                    });
               
                const body = {
                    id: comparejourneyId || undefined,
                    userId:userId || undefined,
                    Source: {
                        Id: sourceSelection?.Id,
                        Name: sourceSelection?.Name
                    },
                    Destination: {
                        Id: destinationSelection?.Id,
                        Name: destinationSelection?.Name
                    },
                    objectConfig: {
                        object: objectSelection[0]?.label || comparejouney?.objectConfig?.object,
                        externalId: getExternalIds(),
                        orderby: orderby,
                        titlefield: titlefield?.label || comparejouney?.objectConfig?.titlefield,
																							 
                        fields: (parentfieldSelection && parentfieldSelection.length > 0)
                            ? parentfieldSelection.map((elem) => elem.label ?? elem)
                            : comparejouney?.objectConfig?.fields || [],
                    },
                    childData: childs || [],
                    filterquery: filterQuery || comparejouney?.filterQuery || '',

                }
                const res = await axios.post(`${DiffChecker_URL}/comparejourney/save`, body);
                setCompareJourney(res.data.data);
                setStage2Open(true);
                setSelectedDiv('div3');
            } catch (error) {

            }


        }

    }

    const handleNextButtonClick = () => {
        switch (selectedDiv) {
            case 'div1':
                handleSaveDiv1();
                break;

            case 'div2':
                handleSaveDiv2();
                break;

            case 'div3':
                setSelectedDiv('div4');
                break;

            default:
                break;
        }
    };

    // 👉 Add this function above return
    const handlePrevButtonClick = () => {
        switch (selectedDiv) {
            case 'div2':
                setSelectedDiv('div1');
                break;
            case 'div3':
                setSelectedDiv('div2');
                break;
            case 'div4':
                setSelectedDiv('div3');
                break;
            default:
                break;
        }
    };

    // === Master View ===
    const masterView = () => {
        const selectedFieldsCount = parentfieldSelection?.length;

        return (
            <div style={{ overflow: 'hidden' }}>
                {/* Div 1 */}
                <div
                    onClick={() => setSelectedDiv('div1')}
                    style={{
                        padding: 12,
                        cursor: 'pointer',
                        backgroundColor: selectedDiv === 'div1' ? '#e6f7ff' : '',

                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {stage1Open ? (
                            <CheckCircleOutlined style={{ color: 'green', fontSize: 25 }} />
                        ) : (
                            <Progress type="circle" percent={0} width={25} format={() => '1'} />
                        )}
                        <span style={{ marginLeft: 8 }}>Select Source and Destination</span>
                    </div>
                    <Row gutter={8} style={{ marginTop: 8 }}>
                        <Col span={12}>
                            <Input
                                placeholder="Selected Source"
                                disabled={true}

                                value={sourceSelection?.Name || ''}
                            />
                        </Col>
                        <Col span={12}>
                            <Input
                                placeholder="Selected Destination"
                                disabled={true}

                                value={destinationSelection?.Name || ''}
                            />
                        </Col>
                    </Row>
                </div>

                {/* Div 2 */}
                <div
                    onClick={() => setSelectedDiv('div2')}
                    style={{
                        padding: 12,
                        cursor: 'pointer',
                        backgroundColor: selectedDiv === 'div2' ? '#e6f7ff' : '',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ flex: '0 0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', width: 30, height: 30 }}>
                            {stage2Open ? (
                                <CheckCircleOutlined style={{ color: 'green', fontSize: 25 }} />
                            ) : (
                                <Progress type="circle" percent={0} width={25} format={() => '2'} />
                            )}
                        </div>
                        <span style={{ marginLeft: 8 }}>Select Object and Fields</span>
                        {selectedFieldsCount > 0 && (

                            <Avatar
                                style={{
                                    marginLeft: 12,
                                    flex: '0 0 auto',
                                    fontSize: 12,          // adjust font size
                                    backgroundColor: '#1890ff', // optional background color
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                                size={20}
                            >
                                <span>{selectedFieldsCount || ''}</span>
                            </Avatar>
                        )}
                    </div>

                    <Row gutter={8} style={{ marginTop: 8 }}>
                        <Col span={12}>
                            <Input
                                placeholder="Selected Object"
                                disabled={true}
                                value={objectSelection[0]?.label || objectSelection || ''}
                            />
                        </Col>
                        <Col span={12}>
                            <Input
                                placeholder="Selected External Id"
                                disabled={true}
                                value={getExternalIds().join(', ')}
                            />
                        </Col>
                    </Row>
                </div>


                {/* Div 3 */}
                <div
                    onClick={() => setSelectedDiv('div3')}
                    style={{
                        padding: 12,
                        cursor: 'pointer',
                        backgroundColor: selectedDiv === 'div3' ? '#e6f7ff' : '',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {stage3Open ? (
                            <CheckCircleOutlined style={{ color: 'green', fontSize: 25 }} />
                        ) : (
                            <Progress type="circle" percent={0} width={25} format={() => '3'} />
                        )}
                        <span style={{ marginLeft: 8 }}>Select Relationship</span>
                        {childRows?.length > 0 && (
                            <Avatar
                                style={{
                                    marginLeft: 12,
                                    flex: '0 0 auto',
                                    fontSize: 12,          // adjust font size
                                    backgroundColor: '#1890ff', // optional background color
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                                size={20}
                            >
                                <span>{childRows?.length || ''}</span>
                            </Avatar>

                        )}
                    </div>
                </div>

                {/* Run Comparison */}
                <div style={{ padding: 12, textAlign: 'center' }}>
                    <Button
                        type="primary"
                        disabled={!(stage1Open && stage2Open)}
                        onClick={handleComparisonButtonClick}
                    >
                        Save & Run Comparison
                    </Button>
                </div>
            </div>
        );
    };

    // === Detail View ===
    const detailView = () => {
        if (comparisonInProgress) {
            return (
                <div
                    style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}
                >
                    <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
                </div>
            );
        }

        if (selectedDiv === 'div1') {
            return (
                <MyCombobox
                    parentCallback={handleCallback}
                    sourceSelection={sourceSelection}
                    destinationSelection={destinationSelection}
                    comparejouney={comparejouney}

                />
            );
        } else if (selectedDiv === 'div2') {
            return (
                <ObjectAndFieldSelector
                    sourceSelection={sourceSelection}
                    destinationSelection={destinationSelection} 
                    parentCallback={handleObjectSelectionCallback}
                    objectSelection={objectSelection}
                    setObjectSelection={setObjectSelection}
                    setExternalIdSelection={setExternalIdSelection}
                    externalIdSelection={externalIdSelection}																   
                    setParentfieldSelection={setParentfieldSelection}
                    parentfieldSelection={parentfieldSelection}
                    titlefield={titlefield}
                    setTitleField={setTitleField}
					orderby={orderby}
                    setOrderby={setOrderby}				 
										   
                    comparejouney={comparejouney}
                    filterQuery={filterQuery}
                    setFilterQuery={setFilterQuery}

                />
            );
        } else if (selectedDiv === 'div3') {
            return (
                <ChildRelationShipSelector
                    sourceSelection={sourceSelection}
                    destinationSelection={destinationSelection}
                    objectSelection={objectSelection}
                    childRows={childRows}
                    externalIdSelection={externalIdSelection}
                    parentCallback={handleChildSelectionCallback}
                    setChildRows={setChildRows}
                    childTitlefield={childTitlefield}
                    setchildTitleField={setchildTitleField}
                    
                    comparejouney={comparejouney}

                />
            );
        } else if (selectedDiv === 'div4') {
            console.log("Rendering MyTableComponent with childTitlefield map:", childTitleFieldMap);
            return (
                <MyTableComponent
                    data={diffResults}
                    sourceRecords={sourceRecords}
                    destinationRecords={destinationRecords}
                    sourcename={sourceSelection?.Name}
                    destinationname={destinationSelection?.Name}
                    titlefield={titlefield?.label || titlefield}
                    className="renderer"
                    childTitlefield={childTitleFieldMap}
                    setSelectedDiv={setSelectedDiv}
                />
            );
        }
    };

    return (
        <Layout style={{ height: '90vh', margin: 0 }}>

            {!collapsed && (
                <Sider
                    width={350}
                    style={{ background: '#fff', borderRight: '1px solid #f0f0f0', overflowY: 'auto', height: '100%' }}
                >
                    {masterView()}
                </Sider>
            )}
            <div
                style={{
                    width: 20,
                    background: '#fff',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center', // keeps icon centered
                    position: 'relative',
                    borderRight: '1px solid #f0f0f0',
                }}
            >
                <div style={{ flex: 1, width: 1, background: '#fff' }} />

                {/* Pure icon toggle */}
                {collapsed ? (
                    <CaretRightOutlined
                        onClick={() => setCollapsed(false)}
                        style={{ fontSize: 16, cursor: 'pointer', color: '#555', margin: '8px 0' }}
                    />
                ) : (
                    <CaretLeftOutlined
                        onClick={() => setCollapsed(true)}
                        style={{ fontSize: 16, cursor: 'pointer', color: '#555', margin: '8px 0' }}
                    />
                )}

                <div style={{ flex: 1, width: 1, background: '#fff' }} />
            </div>

            <Layout>
                <Content style={{ padding: 16, height: '100%', background: '#fff' }}>
                    {detailView()}

                    {selectedDiv !== 'div4' && (
                        <div style={{ marginTop: 16, textAlign: 'right' }}>
                            <Button
                                icon={<CaretLeftOutlined />}
                                style={{ marginRight: 8 }}
                                onClick={handlePrevButtonClick}
                                disabled={selectedDiv === 'div1'} // disable on div1
                            >
                                Prev
                            </Button>

                            {selectedDiv !== 'div3' && (
                                <Button type="primary" onClick={handleNextButtonClick}>
                                    Save & Next
                                </Button>
                            )}
                        </div>
                    )}

                </Content>
            </Layout>

        </Layout>
    );
}

export default DiffCheckerTabs;